import React from 'react';
import b1 from '../assets/b1.png';
import b2 from '../assets/b2.png';
import b3 from '../assets/b3.png';
import b4 from '../assets/b4.png';
import ct1 from '../assets/ct-1.png';
import ct2 from '../assets/ct-2.png';
import ct3 from '../assets/ct-3.png';

const BrandsSection = () => (
  <section className="w-full flex flex-col items-center justify-center py-8">
    <div className="text-xs tracking-widest text-gray-300 uppercase mb-6 text-center"
      style={{
        fontFamily: 'Space Grotesk',
        fontWeight: 500,
        fontSize: 20,
        lineHeight: '24px',
        letterSpacing: '10%',
        maxWidth: 661,
        margin: '0 auto',
      }}
    >
      FROM DAY ONE, OUR CLARITY-FIRST DESIGN EARNED TRUST
    </div>
    <div className="w-full flex flex-row items-center justify-center mt-5 gap-6 flex-wrap">
      {/* Group 1: 4 brands */}
      <div className="flex flex-row items-center gap-6">
        <img src={b1} alt="Brand 1" style={{width: 'clamp(100px, 15vw, 249px)', height: 'auto', maxHeight: 57}} />
        <img src={b2} alt="Brand 2" style={{width: 'clamp(80px, 12vw, 186px)', height: 'auto', maxHeight: 46}} />
        <img src={b3} alt="Brand 3" style={{width: 'clamp(100px, 14vw, 238px)', height: 'auto', maxHeight: 97}} />
        <img src={b4} alt="Brand 4" style={{width: 'clamp(80px, 13vw, 189px)', height: 'auto', maxHeight: 99}} />
      </div>
      {/* Spacer between groups */}
      <div className="w-4 md:w-8" />
      {/* Group 2: ct1, ct2, ct3 */}
      <div className="flex flex-row items-center gap-6">
        <img src={ct1} alt="CT1" style={{width: 'clamp(60px, 8vw, 170px)', height: 'auto', maxHeight: 79}} />
        <img src={ct2} alt="CT2" style={{width: 'clamp(60px, 8vw, 174px)', height: 'auto', maxHeight: 50}} />
        <img src={ct3} alt="CT3" style={{width: 'clamp(40px, 5vw, 60px)', height: 'auto', maxHeight: 81}} />
      </div>
    </div>
  </section>
);

export default BrandsSection;
